export const HIGH_VISIBILITY_MAP_STYLE = [
  { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#c8ced6' }, { weight: 1 }] },
  { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#5f6873' }] },
  { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f4f6f8' }] },
  { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi.business', elementType: 'labels', stylers: [{ visibility: 'on' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#d9dee5' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#737b85' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#edf0f4' }] },
  { featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#d8e7f3' }] }
];
